export default "__VITE_ASSET__89702b94__"